import "./FAQPage.css";
import headerImage from "../images/FAQPage_header.png";
import sprinkleOverlay from "../images/FAQPage_sprinkles.png";
import FAQAccordion from "../components/FAQAccordion";

const FAQPage = () => {
    const faqSections = [
        {
            title: "Getting Started",
            questions: [
                {
                    question: "Where is the ingredient list/zoom link located?",
                    answer: (
                        <p>
                            <ul className="faq-bullets">
                            <li>Once you have registered for a cooking workshop on our{" "}
                            <a
                                href="https://culturedkidscuisine.eventbrite.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="faq-link eventbrite-link"
                            >
                                Eventbrite
                            </a>
                            , you will receive an email with your ticket and more
                            details for accessing the event.</li>
                            <li>Located in the email, please click the large orange box titled "View the event." Once you click on
                            it, you will be led to a page with a link to the Zoom room
                            as well as a full list of ingredients.</li>
                            <li>We recommend that you access this page several days prior to the
                                cooking event to ensure that you have purchased all the necessary
                                ingredients and can locate the Zoom link.
                            </li>
                            <li>If you experience any
                            technical difficulties, please email{" "}
                            <a
                                href="mailto:culturedkidscuisine@gmail.com"
                                className="faq-link mailto-link"
                            >
                                culturedkidscuisine@gmail.com
                            </a>{" "}
                            for assistance.</li>
                            </ul>
                        </p>
                    ),
                },
                {
                    question:
                        "In addition to cooking classes, what other opportunities are offered?",
                    answer: (
                        <p>
                            <ul className="faq-bullets">
                            <li>
                            At Cultured Kids Cuisine, there are a plethora of resources
                            and opportunities to get your children excited about
                            learning. In addition to the cooking workshops, we have a
                            podcast educating children about gastronomic cultural
                            traditions worldwide, “cooktivity” cookbook, a{" "}
                            <a
                                href="https://www.youtube.com/channel/UCyMuT8ywBkYrwxWX_1dK7Gw"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="faq-link youtube-link"
                            >
                                Youtube channel
                            </a>{" "}
                            documenting cooking tutorials with an educational twist, and
                            for a limited time, we will be offering various courses for
                            your children to enroll in!</li>
                            <li>For more information about any
                            of the above services, please contact{" "}
                            <a
                                href="mailto:culturedkidscuisine@gmail.com"
                                className="faq-link mailto-link"
                            >
                                culturedkidscuisine@gmail.com
                            </a>
                            {"."}</li>
                            </ul>
                        </p>
                    ),
                },
            ],
        },
        {
            title: "How CKC Works",
            questions: [
                {
                    question:
                        "How do you decide which classes to run? Do they focus on multi-cultures or one?",
                    answer: (
                        <p>
                            <ul className="faq-bullets">
                            <li>At Cultured Kids Cuisine, there are a plethora of resources
                            and opportunities to get your children excited about
                            learning. One aspect that we deeply pride ourselves on is
                            the fact that we have never repeated the same dish and
                            ensure that we share dishes from all across the globe. Many
                            of our workshops are also hosted by chef influencers who
                            bring their own diverse flavors and backgrounds.</li>
                            <li>For more
                            information about any of the above services, please contact{" "}
                            <a
                                href="mailto:culturedkidscuisine@gmail.com"
                                className="faq-link mailto-link"
                            >
                                culturedkidscuisine@gmail.com
                            </a>
                            {"."}</li>
                            </ul>
                        </p>
                    ),
                },
                {
                    question: "Do you hold private events?",
                    answer: (
                        <p>
                            <ul className="faq-bullets">
                            <li>Yes, we do hold private events. If you are interested in
                            hosting an event with us, please contact{" "}
                            <a
                                href="mailto:culturedkidscuisine@gmail.com"
                                className="faq-link mailto-link"
                            >
                                culturedkidscuisine@gmail.com
                            </a>{" "}
                            and fill out <a
                                href="https://docs.google.com/forms/d/e/1FAIpQLSfgUei-B37maKdGoSuPp-8Rk5A9o9kmLd5Hm1eE6EbKabKosQ/viewform?usp=dialog"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="faq-link eventbrite-link"
                            > this form</a>.</li>
                            <li>We will cater anything from
                            school-wide events to birthday parties. Give us some details
                            about your event and we will facilitate a fun and
                            educational cooking workshop for you!</li>
                            </ul>
                        </p>
                    ),
                },
                {
                    question:
                        "How is Cultured Kids Cuisine funded? Where can I donate?",
                    answer: (
                        <p>
                            <ul className="faq-bullets">
                            <li>We are primarily funded via donations and our{" "}
                            <a
                                href="https://www.gofundme.com/f/cultured-kids-cuisine-funding-amp-donations/donate?source=btn_donate_sticky"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="faq-link gofundme-link"
                            >
                                GoFundMe
                            </a>{" "}
                            page. The success of our organization and outreach is
                            dependent entirely upon the financial support that we
                            recieve.</li>
                            <li>We would like to ask that you consider donating
                            towards our 2026-2027 budget, as this funding will directly
                            benefit furthering a social cause and our global mission to
                            educate children through a novel avenue of learning:
                            cooking. For every $30, you helping us fund one cooking
                            workshop and reach more youth.</li>
                            </ul>
                        </p>
                    ),
                },
            ],
        },
        {
            title: "Resources",
            questions: [
                {
                    question: "How can I get involved or help support the vision?",
                    answer: (
                        <p>
                            <ul className="faq-bullets">
                                <li>We ask that you consider donating to our{" "}
                            <a
                                href="https://www.gofundme.com/f/cultured-kids-cuisine-funding-amp-donations/donate?source=btn_donate_sticky"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="faq-link gofundme-link"
                            >
                                GoFundMe
                            </a>{" "}
                            page, following our social media handles
                            (@culturedkidscuisine on Instagram, Facebook, LinkedIn, and
                            Tik Tok), and promoting our organization's services to
                            friends and family.</li>
                            <li>If you are a high school, college, or
                            graduate, consider applying to our <a
                                href="https://forms.gle/onZ3kyRtUMw5keTF9"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="faq-link eventbrite-link"
                            >5-month entrepreneurship
                            internship program</a>, where you will have access to private
                            networking events, conferences with successful founders, and
                            many helpful free resources to build your resume.</li>
                            </ul>
                        </p>
                    ),
                },
                {
                    question: "What makes Cultured Kids Cuisine different?",
                    answer: (
                        <div>
                            <ul className="faq-bullets">
                                <li>
                                    Firstly, we are run by a team of several hundred
                                    students from all over the world, who volunteer their
                                    time to further our mission and vision of fostering
                                    cultural awareness through food for all those excited
                                    to learn and become more culturally competent! The age
                                    of our volunteers and culinarians is crucial to
                                    delivering educational content that is relevant and
                                    engaging to the population we are servicing-youth!
                                </li>
                                <li>
                                    Additionally, we are truly the first organization of our
                                    kind, hosting 100% free classes educating children about
                                    culture and history through cooking-helping our next
                                    generation develop a broader palate and celebrating
                                    diversity.
                                </li>
                            </ul>
                        </div>
                    ),
                },
            ],
        },
    ];

    return (
        <>
            <header className="faq-header">
                <img
                    src={headerImage}
                    alt="FAQ Header"
                    className="header-image"
                />
                <img
                    src={sprinkleOverlay}
                    alt="Sprinkles"
                    className="header-overlay"
                />
                <div className="header-text">
                    <h2 className="faq-label">Frequently Asked Questions</h2>
                    <h1 className="faq-title">Cookin' Up Questions</h1>
                    <p className="faq-description">
                        Curious about our programs, recipes, or how we bring cultures to life through food? Explore answers to your top questions about all things Cultured Kids Cuisine.
                    </p>
                </div>
            </header>
            <section className="faq-section">
                <div className="faq-content">
                    {faqSections.map((section) => (
                        <div className="faq-group" key={section.title}>
                            <h3 className="faq-group-title">{section.title}</h3>
                            <div className="faq-group-items">
                                {section.questions.map((question) => (
                                    <FAQAccordion
                                        key={question.question}
                                        question={question}
                                    />
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </>
    );
};

export default FAQPage;
